const payCountries = ['US'];

export default payCountries;
